/* Shared collection/search controller. Entire index first, 24 lazy cards at a time. */

if(!customElements.get('gp-collection')) customElements.define('gp-collection',class extends HTMLElement{

  connectedCallback(){

    if(this.started)return;this.started=true;this.abort=new AbortController();this.shown=24;

    this.grid=this.querySelector('[data-grid]');if(!this.grid)return;

    this.heading=this.querySelector('[data-heading]');this.originalHeading=this.heading?.textContent;this.progress=this.querySelector('[data-progress]');this.count=this.querySelector('[data-count]');this.more=this.querySelector('[data-more]');this.status=this.querySelector('[data-status]');

    this.querySelector('[data-controls]').disabled=true;this.count.textContent='…';this.syncNavigation();

    this.querySelector('[data-more]').addEventListener('click',()=>{const old=this.shown;this.shown+=24;this.render();this.grid.children[old]?.querySelector('a')?.focus();});

    this.querySelector('[data-reset]').addEventListener('click',()=>{const u=new URL(location);['taille','couleur','promos','grandes-tailles','rayon','tri'].forEach(k=>u.searchParams.delete(k));history.pushState(null,'',u);this.shown=24;this.render();});

    this.querySelector('[data-retry]').addEventListener('click',()=>this.load());

    this.pop=()=>{if(this.products){this.shown=24;this.render();}};window.addEventListener('popstate',this.pop);

    this.load();

  }

  disconnectedCallback(){this.abort?.abort();window.removeEventListener('popstate',this.pop);}

  async load(){

    this.removeAttribute('data-ready');this.setAttribute('aria-busy','true');this.querySelector('[data-controls]').disabled=true;this.querySelector('[data-retry]').hidden=true;this.querySelector('[data-empty]').hidden=true;this.progress.textContent='Chargement de toutes les tailles disponibles…';

    try{

      const rows=[],seen=new Set();let expected=null,pages=1;

      for(let page=1;page<=pages;page++){

        const u=new URL(location);['taille','couleur','promos','grandes-tailles','rayon','tri','page','sort_by'].forEach(k=>u.searchParams.delete(k));

        u.searchParams.set('section_id','gp-catalog-index');u.searchParams.set('page',String(page));if(location.pathname.endsWith('/search')){u.searchParams.set('type','product');u.searchParams.set('sort_by','price-ascending');}
        const r=await fetch(u,{signal:this.abort.signal,cache:'no-store'});if(!r.ok)throw Error('index');

        const doc=new DOMParser().parseFromString(await r.text(),'text/html'),meta=doc.querySelector('[data-index-page]');if(!meta)throw Error('section');

        const total=Number(meta.dataset.total),nPages=Number(meta.dataset.pages);if(page===1){expected=total;pages=nPages;}else if(total!==expected||nPages!==pages)throw Error('changed');

        if(Number(meta.dataset.page)!==page||pages>100)throw Error('pagination');

        for(const el of doc.querySelectorAll('[data-index-product]')){const p=JSON.parse(el.textContent);if(seen.has(p.id))throw Error('duplicate');seen.add(p.id);p.rayon=window.GPRayons?.[p.id]||({Ensembles:'ensembles',Bodies:'bodys',Bodystockings:'bodys',Nuisettes:'nuit',Peignoirs:'nuit',Corsets:'corsets','Robes lingerie':'robes',Bas:'bas',Collants:'bas'}[p.type]||'');rows.push(p);}

      }

      if(rows.length!==expected)throw Error('incomplete');this.products=rows;this.controls();this.querySelector('[data-controls]').disabled=false;this.render();

      this.setAttribute('data-ready','');this.setAttribute('aria-busy','false');this.querySelector('[data-fallback-next]')?.setAttribute('hidden','');

    }catch(e){if(e.name==='AbortError')return;this.count.textContent='';this.more.hidden=true;this.progress.textContent='Les articles correspondant à votre sélection n’ont pas pu être chargés. Réessayez le chargement.';this.setAttribute('aria-busy','false');this.querySelector('[data-retry]').hidden=false;}

  }

  change(key,values){const u=new URL(location);u.searchParams.delete(key);u.searchParams.delete('page');values.filter(Boolean).forEach(v=>u.searchParams.append(key,v));history.pushState(null,'',u);this.shown=24;this.render();}

  controls(){

    const box=this.querySelector('[data-sizes-ui]');box.querySelectorAll('button').forEach(e=>e.remove());

    const sizes=[...new Set(this.products.flatMap(p=>p.variants.filter(v=>v.available).map(v=>GPCatalog.norm(v.size))))].sort(GPCatalog.sizeSort);

    for(const size of sizes){const b=document.createElement('button');b.type='button';b.dataset.size=size;b.textContent=size;b.addEventListener('click',()=>{const selected=new Set(GPCatalog.state(location.href).sizes);selected.has(size)?selected.delete(size):selected.add(size);this.change('taille',[...selected]);});box.append(b);}

    const colour=this.querySelector('[data-colour]');colour.replaceChildren(new Option('Toutes les couleurs',''));for(const c of [...new Set(this.products.flatMap(p=>p.variants.filter(v=>v.available&&v.colour).map(v=>v.colour)))].sort())colour.add(new Option(c,c));

    colour.onchange=()=>this.change('couleur',[colour.value]);this.querySelector('[data-sort]').onchange=e=>this.change('tri',[e.target.value]);this.querySelector('[data-sale]').onchange=e=>this.change('promos',[e.target.checked?'1':'']);

  }

  syncNavigation(){
    const s=GPCatalog.state(location.href),title=s.large?'Grandes tailles':({corsets:'Corsets',robes:'Robes',ensembles:'Ensembles',bodys:'Bodys',nuit:'Nuit',bas:'Bas & accessoires'}[s.rayon]||this.originalHeading);
    if(this.heading)this.heading.textContent=title;
    const crumb=this.querySelector('.gp-crumbs [aria-current]');if(crumb&&title)crumb.textContent=title;
    document.querySelectorAll('.gp-coll__sister a,.gp-nav a,.gp-drawer a').forEach(link=>{if(GPCatalog.navigationMatches(link.href,location.href))link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');});
    this.querySelectorAll('[data-size]').forEach(b=>b.setAttribute('aria-pressed',String(s.sizes.includes(GPCatalog.norm(b.dataset.size)))));
  }
  render(){
    this.syncNavigation();

    const s=GPCatalog.state(location.href),list=GPCatalog.select(this.products,s),n=list.length;if(this.heading)this.heading.textContent=s.large?'Grandes tailles':({corsets:'Corsets',robes:'Robes',ensembles:'Ensembles',bodys:'Bodys',nuit:'Nuit',bas:'Bas & accessoires'}[s.rayon]||this.originalHeading);this.grid.replaceChildren(...list.slice(0,this.shown).map(p=>this.card(p,s)));

    this.querySelectorAll('[data-size]').forEach(b=>b.setAttribute('aria-pressed',String(s.sizes.includes(b.dataset.size))));this.querySelector('[data-colour]').value=s.colour;this.querySelector('[data-sale]').checked=s.sale;this.querySelector('[data-sort]').value=s.sort;

    this.count.textContent=String(n);this.more.hidden=n<=this.shown;this.querySelector('[data-empty]').hidden=n>0;this.progress.textContent=`${Math.min(n,this.shown)} articles affichés sur ${n} disponibles`;this.status.textContent=this.progress.textContent;

    const label=this.querySelector('[data-active-filter]');label.textContent=[s.large?'XL et au-delà, tailles combinées et libellés Plus Size ou Queen Plus selon les modèles':'',s.rayon?({corsets:'Corsets',robes:'Robes',ensembles:'Ensembles',bodys:'Bodys',nuit:'Nuit',bas:'Bas & accessoires'}[s.rayon]||s.rayon):'',s.sizes.length?'Tailles exactes : '+s.sizes.join(' ou '):''].filter(Boolean).join(' · ');

    this.querySelector('[data-clear]').hidden=!(s.large||s.rayon||s.sizes.length||s.colour||s.sale);this.querySelector('[data-clear]').onclick=()=>this.querySelector('[data-reset]').click();

  }

  card(p,s){

    const el=(tag,cls,text)=>{const e=document.createElement(tag);if(cls)e.className=cls;if(text!=null)e.textContent=text;return e;};const v=p.matched.reduce((a,b)=>a.price<=b.price?a:b);const card=el('article','gp-card');card.dataset.productId=p.id;

    const a=el('a','gp-card__link'),url=new URL(p.url,location.origin);if(s.sizes.length||s.colour||s.large||s.sale)url.searchParams.set('variant',v.id);const preview=new URL(location).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);a.href=url.pathname+url.search;

    const frame=el('div','gp-card__img');if(v.image||p.image){const img=el('img','gp-card__main');img.src=v.image||p.image;img.loading='lazy';img.alt='';img.width=700;img.height=900;frame.append(img);}a.append(frame);

    const body=el('div','gp-card__body');body.append(el('h3','gp-card__title',p.title.replace(/\s+[A-Z]{2}-?\d{3,}$/u,'')));const money=x=>(x/100).toLocaleString('fr-FR',{style:'currency',currency:'EUR'});const price=el('p','gp-card__price',(new Set(p.matched.map(x=>x.price)).size>1?'Dès ':'')+money(v.price));if(v.compare>v.price){price.append(document.createTextNode(' '),el('s','',money(v.compare)));}body.append(price,el('p','gp-card__meta',[...new Set(p.matched.map(x=>x.size))].join(' · ')));a.append(body);card.append(a);return card;
  }

});